import { ItemsForm, ItemsState } from "../types";

export const initialItemsForm: ItemsForm = {
  item: "",
  detailedDescription: "",
  height: "",
  width: "",
  length: "",
  thickness: "",
  weight: "",
  group: "",
  notes: "",
};

export const initialState: ItemsState = {
  loading: false,
  saving: false,
  list: [],
  error: null,
  isAddModalOpen: false,
  form: initialItemsForm,
  detail: null,
  detailLoading: false,
  detailError: null,
};
